/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $ from 'jquery';
import {load} from '@shopify/theme-sections';
import Variants from '@shopify/theme-variants';
import {formatMoney} from '@shopify/theme-currency';
import {register} from '@shopify/theme-sections';
import Swiper, { Navigation, Thumbs, FreeMode, A11y, Keyboard } from 'swiper';
import Drift from 'drift-zoom';

// // Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';


var localeUrl = window.localeUrl;

const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productImageWrapper: '[data-product-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-page]',
    productPrice: '[data-product-price]',
    productThumbnailsSlider: 'carousel--product-thumbnails',
    productFeatureSlider: 'carousel--featured-product',
    productThumbs: '[data-product-single-thumbnail]',
    radioOptionSelector: '[data-radio-option-selector]',
    singleOptionSelector: '[data-single-option-selector]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaTypeVideo: '[data-product-media-type-video]',
    productMediaTypeModel: '[data-product-media-type-model]',
    variantOptionLabels: '.swatch__option label',
    quantity: '#Quantity',
    productSwiperThumbs: null,
    productSwiperFeature: null,
    notifyCartButton: '.button__notify-restock',
    variantIdSelector: '[data-variant-id]',
    moneyFormat: window.localeUrl == '/fr' ? "{{amount_with_comma_separator}} $" : theme.moneyFormat,
};

const cssClasses = {
    activeThumbnail: 'active-thumbnail',
    hide: 'hide',
};

const keyboardKeys = {
    ENTER: 13,
};


function toggleInnerFocus(slider) {
    let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    $(focusableElements).each(function(index, el) {
        $(slider.slides).each(function(index, slide) {
            if (index === slider.activeIndex) {
                if (el === '.plyr') {
                    $(slide).find(el)
                    .attr('tabindex', "0");
                } else {
                    $(slide).find(el)
                    .removeAttr('tabindex');
                }
            } else {
                $(slide)
                .find(el)
                .attr('tabindex', '-1');
            }
        })
    })
}

$(document).ready(function(){
    var ProductVideo = (function() {
      var videos = {};

      var hosts = {
        html5: 'html5',
        youtube: 'youtube'
      };

      var attributes = {
        enableVideoLooping: 'enable-video-looping',
        videoId: 'video-id'
      };

      function init(videoContainer, sectionId) {
        if (!videoContainer.length) {
          return;
        }

        var videoElement = videoContainer.find('iframe, video')[0];
        var mediaId = videoContainer.data('mediaId');

        if (!videoElement) {
          return;
        }

        videos[mediaId] = {
          mediaId: mediaId,
          sectionId: sectionId,
          host: hostFromVideoElement(videoElement),
          container: videoContainer,
          element: videoElement,
          ready: function() {
            createPlayer(this);
          }
        };

        var video = videos[mediaId];
        switch (video.host) {
          case hosts.html5:
            setupPlyrVideos();
            break;
          case hosts.youtube:
            setupYouTubeVideos();
            break;
        }
      }

      function setupPlyrVideos() {
        // if (errors) {
        //   fallbackToNativeVideo();
        //   return;
        // }

        loadVideos(hosts.html5);
      }

      function setupYouTubeVideos() {

        window.YT.ready(function() {
            loadVideos(hosts.youtube);
        });
      }

      function createPlayer(video) {
        if (video.player) {
          return;
        }

        var productMediaWrapper = video.container.closest(
          selectors.productMediaWrapper
        );
        var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

        switch (video.host) {
          case hosts.html5:
            // eslint-disable-next-line no-undef
            video.player = new Shopify.Plyr(video.element, {
              loop: { active: enableLooping }
            });

            video.player.on('ready', function() {
                toggleInnerFocus(selectors.productSwiperFeature);
            })
            break;
          case hosts.youtube:
            var videoId = productMediaWrapper.data(attributes.videoId);

            video.player = new YT.Player(video.element, {
              videoId: videoId,
              events: {
                onStateChange: function(event) {
                  if (event.data === 0 && enableLooping) event.target.seekTo(0);
                }
              }
            });
            break;
        }

        productMediaWrapper.on('mediaHidden xrLaunch', function() {
          if (!video.player) return;

          if (video.host === hosts.html5) {
            video.player.pause();
          }

          if (video.host === hosts.youtube && video.player.pauseVideo) {
            video.player.pauseVideo();
          }
        });

        productMediaWrapper.on('mediaVisible', function() {
            if (!video.player) return;

            if (video.host === hosts.html5) {
                video.player.play();
            }

            if (video.host === hosts.youtube && video.player.playVideo) {
                video.player.playVideo();
            }
        });
      }

      function hostFromVideoElement(video) {
        if (video.tagName === 'VIDEO') {
          return hosts.html5;
        }

        if (video.tagName === 'IFRAME') {
          if (
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
              video.src
            )
          ) {
            return hosts.youtube;
          }
        }
        return null;
      }

      function loadVideos(host) {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            if (video.host === host) {
                video.ready();
            }
          }
        }
      }

      function fallbackToNativeVideo() {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.nativeVideo) continue;

            if (video.host === hosts.html5) {
              video.element.setAttribute('controls', 'controls');
              video.nativeVideo = true;
            }
          }
        }
      }

      function removeSectionVideos(sectionId) {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.sectionId === sectionId) {
              if (video.player) video.player.destroy();
              delete videos[key];
            }
          }
        }
      }

      return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
      };
    })();

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register('product', {
        onLoad() {
            this.$container = $(this.container);
            this.namespace = `.${this.id}`;
            var self = this;

            // Stop parsing if we don't have the product json script tag when loading
            // section in the Theme Editor
            if (!$(selectors.productJson, this.$container).html()) {
                return;
            }

            this.productSingleObject = JSON.parse(
                $(selectors.productJson, this.$container).html(),
            );

            this.initProductVariantSelection();

            const options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                radioOptionSelector: this.radioOptionSelector,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject,
            };

            this.settings = {};
            this.variants = new Variants(options);
            this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

            // Work & Safety Products, select the first variant of the men's size
            if( $(this)[0]['id'] == "product--work-safety" ) {
                this.initWorkSafetyProductVariantSelectionUpdate({
                    variant: this.variants.currentVariant
                });
            }

            this.$container.on(
                `variantChange${this.namespace}`,
                this.updatePDPInformation.bind(this)
            );
            this.$container.on(
                `variantPriceChange${this.namespace}`,
                this.updateProductPrices.bind(this),
            );

            $('.form__increment').on('click', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            $(selectors.quantity).on('change', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            if (this.$featuredImage.length > 0) {
                this.$container.on(
                    `variantImageChange${this.namespace}`,
                    this.updateImages.bind(this),
                );
            }

            this.$container.on('submit', 'form.product-form', function(event) {
            var $form = $(this);
            var isUpSell = $form.data('product-up-sell');

            if (isUpSell) {
                if ($form.find('input[name="properties[iamota]"]').length === 0) {
                $('<input>').attr({
                    type: 'hidden',
                    name: 'properties[iamota]',
                    value: 'comp'
                }).appendTo($form);
                }
            }
            });

            this.initProductCarousel();
            this.initProductVideo();
            this.updateImages({
                variant: this.variants.currentVariant
            });
            this.initVariantTitles();
            this.initVariantHoverWatch();
            this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
            this.initStickyCart();
            this.initProductZoom();
        },

        initProductVariantSelection: function() {
            let selectedInputs = document.querySelectorAll('[data-single-option-selector][data-selected]');
            if (selectedInputs.length > 0) {
               selectedInputs[0].click();
            }

            // Work & Safety Products, select the first variant of the men's size
            if( $(this)[0]['id'] == "product--work-safety" ) {
                let allInputs = document.querySelectorAll('[data-single-option-selector]');
                let workSafetySelectorInput = document.querySelector('[data-option-mens-size]');
                if ( $(workSafetySelectorInput).length ) {
                    $(allInputs).prop( 'checked', false )
                    $(workSafetySelectorInput).prop( 'checked', true )
                }
            }
        },

        initWorkSafetyProductVariantSelectionUpdate(evt) {
            const selectedVariantID = evt.variant.id;
            let productSelect = document.querySelectorAll('[data-product-select]');
            let productSelectOption = $(productSelect).children('option');
            let data_variant_id = document.querySelector('[data-variant-id]');

            $(productSelectOption).prop( 'selected', false )

            $(productSelectOption).each(function(){
                if ( $(this).attr('value') ==  selectedVariantID ) {
                    $(this).prop('selected', true)
                }
            });

            if ( $(data_variant_id).length ) {
                $(data_variant_id).attr( 'data-variant-id', selectedVariantID );

                if ( !this.variants.currentVariant.available ) {
                    $(selectors.addToCart, this.$container).prop('disabled', true);
                    $(data_variant_id).removeClass('hide');
                }
            }
        },

        initProductVideo: function() {
            var sectionId = this.id;
            $(selectors.productMediaTypeVideo, this.$container).each(function() {
                var $el = $(this);
                ProductVideo.init($el, sectionId);
            });
        },

        initProductCarousel: function() {
            let self = this;
            // -------------------------------------
            // Carousel Products
            // -------------------------------------
            const productThumbnailSwiper = new Swiper('.'+selectors.productThumbnailsSlider+'', {
                // Optional parameters
                modules: [Navigation, FreeMode, A11y, Keyboard],
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                navigation: true,
                observer: true,
                observeParents: true,
                autoHeight: true,
                watchOverflow: true,
                threshold: 10,

                keyboard: {
                    enabled: false
                },
                a11y: false,
                breakpoints: {
                    // when window width is >= 680px
                    680: {
                        direction: "horizontal",
                        slidesPerView: 7,
                        spaceBetween: 10
                    }
                },
                multipleActiveThumbs: false
            });

             const productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'', {
                // Optional parameters
                modules: [Navigation, Thumbs],
                spaceBetween: 0,
                autoHeight: true,

                // // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next-product',
                    prevEl: '.swiper-button-prev-product',
                },
                thumbs: {
                  swiper: productThumbnailSwiper,
                },
                on: {
                    init: function() {
                        toggleInnerFocus(this);
                    }
                }
            });


             productFeatureSwiper.on('slideChange ', function () {
              // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                var previousSlideIndex = productFeatureSwiper.previousIndex,
                    currentSlideIndex = productFeatureSwiper.activeIndex;

                // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                    previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');

                previousMedia.trigger("mediaHidden");
                currentMedia.trigger("mediaVisible");
                  toggleInnerFocus(this);

            });

            $(productFeatureSwiper.slides).each(function(index, slide) {
                $(slide).on('keydown', function(e) {
                    if (e.key === "Escape") {
                        $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                            $(thumbnailSlide).attr('tabindex', '0');
                        })

                        productThumbnailSwiper.slides[index].focus();
                    }
                })
            })



            $(productThumbnailSwiper.slides).each(function(index, slide) {
                $(slide).on('focus', function(e) {
                    let slideIndex = slide.getAttribute('data-index');
                    self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                    self.slideToSlide(productFeatureSwiper, slideIndex, true);
                    $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                        $(thumbnailSlide).attr('tabindex', '0');
                    })
                })
                $(slide).on('keydown', function(e) {
                    if (e.key === "Enter") {
                        $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                            $(thumbnailSlide).attr('tabindex', '-1');
                        })
                        $(slide).attr('tabindex', '0');
                        let slideIndex = parseInt(slide.getAttribute('data-index'));
                        productFeatureSwiper.slides[slideIndex].focus();
                    }
                })
            });

            $(productThumbnailSwiper.navigation.nextEl).on('click', function(e) {
                let slideIndex = productThumbnailSwiper.activeIndex;
                self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                self.slideToSlide(productFeatureSwiper, slideIndex, true);
            })

            $(productThumbnailSwiper.navigation.prevEl).on('click', function(e) {
                let slideIndex = productThumbnailSwiper.activeIndex;
                self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                self.slideToSlide(productFeatureSwiper, slideIndex, true);
            })



            selectors.productSwiperThumbs = productThumbnailSwiper;
            selectors.productSwiperFeature = productFeatureSwiper;
        },


        initVariantTitles() {
            this.changeVariantTitles(this.variants.currentVariant);
        },
        disableVariants(target, valuesToEnable) {
            var option1 = $(target).find('input[data-index="option1"]');
            var option2 = $(target).find('input[data-index="option2"]');
            var option3 = $(target).find('input[data-index="option3"]');

            let getSiblings = function (e) {
                // for collecting siblings
                let siblings = [];
                // if no parent, return no sibling
                if(!e.parentNode) {
                    return siblings;
                }
                // first child of the parent node
                let sibling  = e.parentNode.firstChild;
                // collecting siblings
                while (sibling) {
                    if (sibling.nodeType === 1 && sibling !== e) {
                        siblings.push(sibling);
                    }
                    sibling = sibling.nextSibling;
                }
                return siblings;
            };

            option1.each(function() {
                var input = $(this)[0];
                var siblings = getSiblings(input);

                $(siblings).each(function(){
                    $(this).removeClass('swatch--disabled');
                });
                //$(input.nextElementSibling).removeClass('swatch--disabled');

                if (!valuesToEnable.option1.includes(input.value)) {
                    //$(input.nextElementSibling).addClass('swatch--disabled');
                    $(siblings).each(function(){
                        $(this).addClass('swatch--disabled');
                    });
                }
            })
            option2.each(function() {
                var input = $(this)[0];
                var siblings = getSiblings(input);

                $(siblings).each(function(){
                    $(this).removeClass('swatch--disabled');
                });
               // $(input.nextElementSibling).removeClass('swatch--disabled');
                if (!valuesToEnable.option2.includes(input.value)) {
                    //$(input.nextElementSibling).addClass('swatch--disabled');
                     $(siblings).each(function(){
                        $(this).addClass('swatch--disabled');
                    });
                }
            })
            option3.each(function() {
                var input = $(this)[0];
                var siblings = getSiblings(input);

                $(siblings).foreach(function(){
                    $(this).removeClass('swatch--disabled');
                });

                //$(input.nextElementSibling).removeClass('swatch--disabled');
                if (!valuesToEnable.option3.includes(input.value)) {
                    //$(input.nextElementSibling).addClass('swatch--disabled');
                    $(siblings).foreach(function(){
                        $(this).addClass('swatch--disabled');
                    });
                }
            })
        },
        updateVariantAvailability(target, variant) {

            var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }

            // If variant doesn't exist, don't try to update variant availability
            if (!variant) {
                return;
            }

            var variants = this.variants.product.variants;

            var currentVariant = {
                id: variant.id,
                title: variant.title,
                option1: variant.option1,
                option2: variant.option2,
                option3: variant.option3
            };

            // Combine all available variants
            var availableVariants = variants.filter(function(el) {
                if (!el.available) {
                    return false;
                }
                // Option 1
                if ((currentVariant.option2 === el.option2 || !el.option2) && (currentVariant.option3 === el.option3 || !el.option3)) {
                    return true;
                }

                // Option 2
                if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option3 === el.option3 || !el.option3)) {
                    return true;
                }

                // Option 3
                if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option2 === el.option2 || !el.option2)) {
                    return true;
                }
                });

              var variantObject = {
                variant: currentVariant
              };
              availableVariants = Object.assign({}, variantObject, availableVariants);

            for (var property in availableVariants) {
                if (availableVariants.hasOwnProperty(property)) {
                  var item = availableVariants[property];
                  var option1 = item.option1;
                  var option2 = item.option2;
                  var option3 = item.option3;

                  if (option1) {
                    if (availableValues.option1.indexOf(option1) === -1) {
                        availableValues.option1.push(option1);
                    }
                  }
                  if (option2) {
                    if (availableValues.option2.indexOf(option2) === -1) {
                      availableValues.option2.push(option2);
                    }
                  }
                  if (option3) {
                    if (availableValues.option3.indexOf(option3) === -1) {
                      availableValues.option3.push(option3);
                    }
                  }
                }
            }

            this.disableVariants(target, availableValues);
        },


        slideToSlide(slider, slideIndex, transition) {
            if (transition) {
                slider.slideTo(slideIndex);
            } else {
                slider.slideTo(slideIndex, 0);
            }
        },

        // triggering change image when using with Slider
        swapImage(imageId) {

            let newImageId = imageId;

            // If "imageId" is not defined in the function parameter, find it by the current product image
            if (typeof newImageId === 'undefined') {
                newImageId = $(
                    `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
                ).data('image-id');
            }

            const $thumbnail = $(
                `${selectors.productThumbs}[data-thumbnail-id='${newImageId}']`,
            );



            var slideIndex = parseInt($thumbnail.parents('.swiper-slide').attr('data-index'));

            // Swipe JS
            this.slideToSlide(selectors.productSwiperThumbs, slideIndex, false);
            this.slideToSlide(selectors.productSwiperFeature, slideIndex, false);

        },

        initProductZoom: function() {
            if (matchMedia('(pointer:fine)').matches && $(window).width() > 1006) {

                const driftImgs = document.querySelectorAll('.drift-img');
                const pane = document.querySelector('.drift-pane');


                if(driftImgs.length != 0) {
                    for (var i = 0; i < driftImgs.length; ++i) {
                        new Drift(driftImgs[i], {
                            paneContainer: pane,
                            inlinePane: false,
                            handleTouch: false,
                            injectBaseStyles: true,
                            hoverDelay: 200,
                        });
                    }
                }
            }
        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState(evt) {
            const variant = evt.variant;
            this.updateVariantAvailability(evt.target, variant);
            let variantIdSelectors = document.querySelectorAll(selectors.variantIdSelector);
            variantIdSelectors.forEach(variantData => {
                variantData.setAttribute("data-variant-id", variant.id);
            })

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
                $(selectors.notifyCartButton, this.$container).addClass(cssClasses.hide);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCart, this.$container).addClass(cssClasses.hide);
                $(selectors.notifyCartButton, this.$container).removeClass(cssClasses.hide);
                $(selectors.addToCartText, this.$container).html(
                    theme.strings.unavailable,
                );
                $(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);

                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCart, this.$container).removeClass(cssClasses.hide);
                $(selectors.notifyCartButton, this.$container).addClass(cssClasses.hide);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.notifyCartButton, this.$container).removeClass(cssClasses.hide);
                $(selectors.addToCart, this.$container).addClass(cssClasses.hide);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        changeVariantTitles(evt) {
          $('.swatch__option input[data-single-option-selector]:checked').each(function() {
            var container = $(this).parents('.form__element');
            var subtitle = container.find('.swatch__title .swatch__subtitle');
            var subtitleSticky = $('.swatch__title--sticky .swatch__subtitle');
            subtitle.text($(this).val());

            subtitleSticky.text($(this).val());
          })
        },

        tempChangeVariantTitle(evt) {
          var target = evt.currentTarget;
          var newLabel = $(target).parents('.swatch__option');
          var newLabelValue = $(newLabel).find('input[data-single-option-selector]').attr('value');
          var container = $(target).parents('.form__element');
          var subtitle = container.find('.swatch__title .swatch__subtitle');
          var subtitleSticky = $('.swatch__title--sticky .swatch__subtitle');
          subtitle.text(newLabelValue);
          subtitleSticky.text(newLabelValue);
        },

        initVariantHoverWatch() {
          var changeVariantTitles = this.changeVariantTitles;
          var tempChangeVariantTitle = this.tempChangeVariantTitle;
          $('.swatch__option input[data-single-option-selector] ~ label.form__option-label').each(function() {
            $(this).on('mouseenter', tempChangeVariantTitle).on('mouseleave', changeVariantTitles);
          });
        },

        updatePDPInformation(evt) {
          this.updateAddToCartState(evt);
          this.changeVariantTitles(evt);
        },

        updateImages(evt) {
            const variant = evt.variant;

            if (typeof variant.featured_media != 'undefined') {

                const imageId = this.id + "-" + variant.featured_media.id;

                this.swapImage(imageId);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices(evt) {
            const variant = evt.variant;
            const $comparePrice = $(selectors.comparePrice, this.$container);
            const $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container,
            );
            const quantity = parseInt($(selectors.quantity).val());

            $(selectors.productPrice, this.$container).html(
                formatMoney(variant.price, selectors.moneyFormat),
            );

            const priceWithQuantity = variant.price * quantity;
            $('#addToCartPricing').html(
                formatMoney(priceWithQuantity, selectors.moneyFormat),
            );

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    formatMoney(variant.compare_at_price, selectors.moneyFormat),
                );
                $compareEls.removeClass(cssClasses.hide);
            } else {
                $comparePrice.html('');
                $compareEls.addClass(cssClasses.hide);
            }
        },

        initStickyCart() {
          let options = {
            rootMargin: '100px 0px 0px 0px',
            threshold: [0,0.01,1]
          }

          let target = document.querySelector('#productStickyContainer');

          let observer = new IntersectionObserver(this.showHideStickyCart, options);

          observer.observe(target);

          // Mobile cart button
          $('#addToCartSticky').on('click', function() {
            target.scrollIntoView({ behavior: 'smooth' });
          })

        },

        showHideStickyCart(entries, observer) {
            let entry = entries[0];
            if (entry.intersectionRatio >= 1) {
                entry.target.classList.remove('product__sticky--show');
            } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                entry.target.classList.add('product__sticky--show');
                entry.target.classList.remove('product__sticky--hide');
            } else {
                entry.target.classList.add('product__sticky--hide');
            }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
            this.$container.off(this.namespace);
        },
    });

    load('product');
})
